import React from "react";
import "./style.scss";
import { useSelector } from "react-redux";
import { Ticket } from "../../models/Ticket";
import SelectPassModalFooter from "./selectPass/selectPassModalFooter";
import { State } from "../../store";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import SingleExerciseMobile from "./selectPass/singleExerciseMobile";
import SingleExerciseDesktop from "./selectPass/singleExerciseDesktop";
import EAAlert from "../shared/EAAlert";


interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}

const ExercisesPlan: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );
  const isDesktop = useDesktopSize();

  return (
    <>
 
      {ticket.exercises ? (
        <div>
          {ticket.exercises.map((exercise, index) => (
            <div key={index}>
              {isDesktop ? (
                <SingleExerciseDesktop exercise={exercise} getSelect={getSelect} />
              ) : (
                <SingleExerciseMobile exercise={exercise} getSelect={getSelect} />
              )}
            </div>
          ))}
        </div>
      ) : (

        <EAAlert message={"Brak nadchodzących rezerwacji"} type="error" />
      )}

      {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
    </>
  );
};

export default ExercisesPlan;
